import { Component, Inject, ViewChild } from '@angular/core';
import { VentanaFlotante } from '../../models/VentanaFlotante';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComentarioComponent } from './comentario/comentario.component';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { UsuarioService } from '../../services/user.service';
import { DatoDetallePeticion } from '../../models/DatoDetallePeticion';
import { GestionPeticionService } from '../../services/bd/GestionPeticion/gestion-peticion.service';
import { DetallePetcicion } from './DetallePetcicion';
import {AlertArgumentarioComponent} from "../../../VistasGenericas/alert-argumentario/alert-argumentario.component";
import {ListadoComentariosComponent} from "../../listado-comentarios/listado-comentarios.component";
import { traducirTipoGestion } from '../../models/PeticionWeb';
@Component({
  selector: 'ral-detalle-peticion',
  templateUrl: './detalle-peticion.component.html',
  styleUrls: ['./detalle-peticion.component.scss']
})
export class DetallePeticionComponent extends VentanaFlotante
{
  comentarioColumns :string[] = ["Lin.","Fecha/Hora","Comentário","Usuario"];
  comentarios:ComentarioContact[] = [];
  comentarioSource: MatTableDataSource<ComentarioContact> = new MatTableDataSource(this.comentarios);
  usuario:string = "";
  infoPeticion : DetallePetcicion = new DetallePetcicion();
  mostrarCarga:boolean = true;
  estadoAnterior: string = "";
  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private dialogComentario : MatDialog, // Additional parameter to override in the constructor
    private userService:UsuarioService,
    private peticionService:GestionPeticionService,
    private dialog: MatDialog
  )
  {super(dialogRef, data);}

  ngOnInit() {
      //this.peticionService.getPeticionForId(this.data.token, this.data.peticion.toString(),this.data.padre.controlGestion,this.data.padre.tipoGestion).then(res => {
      this.peticionService.getPeticionForId(this.data.token, this.data.peticion.toString(),this.data.padre.controlGestion,this.data.tipo).then(res => {
        switch (this.data.padre.controlGestion){
          case "outbound":
            this.infoPeticion.convertirDesdeOutbound(res);
            break;
          case "gestionWebNew":
            this.infoPeticion.tipo = traducirTipoGestion(this.data.tipo);
            if (this.data.tipo == 3){
              this.infoPeticion.convertirDesdeWebNew(res);
            }else{
              this.infoPeticion.convertirDesdeWebNewElse(res);
            }
            break;
          case "gestionWeb":
            this.infoPeticion.tipo = this.data.padre.nombreGestion;
            this.infoPeticion.convertirDesdeWeb(res);
            break;
          case "segurCaixa":
            this.infoPeticion.tipo = "Gestión SegurCaixa";
            this.infoPeticion.convertirDesdeSegurCaixa(res);
            break;
          case "TUVOZ":
            this.infoPeticion.tipo = "Gestión TUVOZ";
            this.infoPeticion.convertirTUVOZ(res);
            break;
          case "REPARABRISAS RLS":
            this.infoPeticion.tipo = "Gestión Reparabrisas RLS";
            this.infoPeticion.convertirCorredores(res);
            break;
          case "rauda":
            this.infoPeticion.tipo = "Gestión IA Rauda";
            this.infoPeticion.convertirRauda(res);
            break;

        }
      }).finally(() => {
        this.usuario = this.userService.getNombreCuenta();
          this.peticionService.getLineasComentario(this.data.token, this.data.peticion, this.data.padre.controlGestion)
            .then(res => {
              this.comentarios = res;
              this.comentarioSource.data = this.comentarios;
              this.estadoAnterior = this.infoPeticion.estado;
            })
            .catch(err => {
              this.data.padre.hojaprin.mostrarArgumentario("Error", ["Ha habido un error al insertar el comentario"], false, true, true);
              this.mostrarCarga = false;
            })
            .finally(() => {
              this.mostrarCarga = false;
            })
      });

  }
  //se abre el
  agregarComentario()
  {
    const dialogRef = this.dialogComentario.open(ComentarioComponent,
      {data:
        {
          token:this.data.token,
          idPeticion:this.data.peticion,
          tipo: this.data.padre.controlGestion,
          numNuevaLinea : this.comentarios.length+1//EL CONTROLLER YA SE ENCARGA DE CALCULAR EL NUMERO DE LINEA
        }
      }
    );

    dialogRef.afterClosed()
    .subscribe(result =>
    {
      //SI el result es valido
      if(result != undefined && result != null && result != "")
      {
        const hoyAhora = this.getHoy();
        //asignamos el taller seleccionado del buscador al form principal
        this.agregarOrdenado(result);
      }
    });
  }

  //vuelca los datos del detalle a la ventana principal
  generarHoja()
  {
    this.generarDatosDetalle();
    this.dialogRef.close(true);
  }
  //retorna la fecha y hora actuales en formato string
  private getHoy():string
  {
    const currentDate = new Date();
    return currentDate.toLocaleString('es-ES',
    {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  //agrega el comentario nuevo y ordena el listado
  //despues, actualiza el source
  private agregarOrdenado(comentario:ComentarioContact)
  {
    this.comentarios.push(comentario);
    // Ordenamos el array por linea (Descendiente)
    this.comentarios = this.ordenarComentariosPorLinea(this.comentarios);
    this.comentarioSource.data=this.comentarios;
  }

  abrirGrande(){
    const listado = this.dialog.open(ListadoComentariosComponent, {
      data: { datos:this.comentarios, columns:['linea', 'created', 'obser', 'usuario'] },
    });
  }
  private ordenarComentariosPorLinea(comentarios: ComentarioContact[]): ComentarioContact[]
  {
    return comentarios.sort((a, b) => b.linea - a.linea);
  }

  //crea un objeto DatoDetallePeticion
  //para pasarlo a la ventana principal
  generarDatosDetalle()
  {
    switch (this.data.padre.controlGestion){
      case "segurCaixa":
        DatoDetallePeticion.convertirPeticionSegu(this.infoPeticion, this.data.padre.formInic);
        break;
      case "gestionWebNew":
        if(this.data.padre.tipoGestion == 3){
          DatoDetallePeticion.convertirPeticionWebNew(this.infoPeticion, this.data.padre.formInic);
        }else{
          DatoDetallePeticion.convertirPeticionWebElse(this.infoPeticion, this.data.padre.formInic);
        }
        break;
      case "gestionWeb":
        DatoDetallePeticion.convertirPeticionWeb(this.infoPeticion, this.data.padre.formInic);
        break;
      case "outbound":
        DatoDetallePeticion.convertirPeticionOut(this.infoPeticion, this.data.padre.formInic);
        break;
      case "TUVOZ":
        DatoDetallePeticion.convertirCoris(this.infoPeticion, this.data.padre.formInic);
        break;
      case "REPARABRISAS RLS":
        DatoDetallePeticion.convertirReparabrisas(this.infoPeticion, this.data.padre.formInic);
        break;
      case "rauda":
        DatoDetallePeticion.convertirPeticionRauda(this.infoPeticion, this.data.padre.formInic);
        break;
    }
  }

  cambiarEstado(nuevoEstado: string){
    const dialogRef = this.data.padre.formInic.dialog.open(AlertArgumentarioComponent,
      {
        data: {
          titulo: "Atención",
          lineas: ["Realmente desea cambiar el estado de la petición?"],
          mostrarBtnAceptar: true
        }
        ,disableClose:true
      });
    dialogRef.afterClosed().subscribe((result: boolean)  => {
      if (result){
        this.estadoAnterior = nuevoEstado;
        let paramArr = [];
        let param;
        switch (this.data.padre.controlGestion)
        {
          case "outbound":
            param = {
              "id": this.data.peticion,
              "estado": this.infoPeticion.convertirEstadoUpdate(nuevoEstado),
              "usuario": this.userService.getNombreCuenta()
            }
            paramArr.push(param);
            break;
          case "gestionWebNew":
            param = {
              "id": this.data.peticion,
              "estado_contact": this.infoPeticion.convertirEstadoUpdate(nuevoEstado),
              "usuario": this.userService.getNombreCuenta()
            }
            paramArr.push(param);
            break;
          case "gestionWeb":
            param = {
              "id": this.data.peticion,
              "par1": this.infoPeticion.convertirEstadoUpdate(nuevoEstado)
            }
            paramArr.push(param);
            break;
          case "segurCaixa":
            param = {
              "id": this.data.peticion,
              "estado_contact": this.infoPeticion.convertirEstadoUpdate(nuevoEstado)
            }
            paramArr.push(param);
            break;
          case "TUVOZ":
            param = {
              "pet": this.data.peticion,
              "par_001": this.infoPeticion.convertirEstadoUpdate(nuevoEstado)
            }
            paramArr.push(param);
            break;
          case "REPARABRISAS RLS":
            param = {
              "id": this.data.peticion,
              "par1": this.infoPeticion.convertirEstadoUpdate(nuevoEstado)
            }
            paramArr.push(param);
            break;
          case "rauda":
            param = {
              "id": this.data.peticion,
              "estado_contact": this.infoPeticion.convertirEstadoUpdate(nuevoEstado),
              "usuario": this.userService.getNombreCuenta()
            }
            paramArr.push(param);
            break;
        }
        this.peticionService.UpdateEstadoWeb(this.data.token, this.data.padre.controlGestion, paramArr, Number(this.data.tipo)).then(
          (res: any) => {
            if(res){
              this.data.padre.formInic.mostrarArgumentario("OK",["Se ha cambiado el estado de la petición.!"],true);
              this.data.padre.buscar();
            }
          },
          (err:any) => {
            this.data.padre.formInic.mostrarArgumentario("Error", [err.message], true, true, true);
          }
        )
      }else{
        this.infoPeticion.estado= this.estadoAnterior;
      }
    });
  }

}

export interface ComentarioContact
{
  linea:number, created:string,obser:string,usuario:string;
}
